var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaladCardsPreviousBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 60,
    viewBox: "0 0 29 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_6",
    "data-name": "Polygon 6",
    d: "M27.915,2.016a3,3,0,0,1,4.17,0l22.58,21.827A3,3,0,0,1,52.58,29H7.42a3,3,0,0,1-2.085-5.157Z",
    transform: "translate(0 60) rotate(-90)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaladCardsPreviousBtn);
export default __webpack_public_path__ + "static/media/walad_cards_previousBtn.2b125310.svg";
export { ForwardRef as ReactComponent };